import { isLayoutScopedFieldKey } from '@/common/utils/layoutScopedClientFields'

/** Ограничивает map полей ключами, принадлежащими панели. */
export function scopeFieldMapToKeys(
  fields: Record<string, unknown> | null | undefined,
  keys: ReadonlySet<string>,
): Record<string, unknown> {
  if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
    return {}
  }
  const scoped: Record<string, unknown> = {}
  for (const key of keys) {
    if (key in fields) {
      scoped[key] = fields[key]
    }
  }
  return scoped
}

/**
 * Дополняет ключи панели именами из layout XML и platform-суффиксами ответа
 * (`selectedServices__template` и т.п.), когда forms/registry пусты (dialogClosedNReturn).
 */
export function expandReloadPanelFieldKeys(input: {
  panelFieldKeys: ReadonlySet<string>
  layoutFieldNames: ReadonlySet<string>
  resultFields?: Record<string, unknown> | null
}): Set<string> {
  const layoutNames = new Set<string>([
    ...input.layoutFieldNames,
    ...input.panelFieldKeys,
  ])
  const expanded = new Set<string>(layoutNames)
  const resultFields = input.resultFields
  if (resultFields && typeof resultFields === 'object' && !Array.isArray(resultFields)) {
    for (const key of Object.keys(resultFields)) {
      if (isLayoutScopedFieldKey(key, layoutNames)) {
        expanded.add(key)
      }
    }
  }
  return expanded
}

/** Поля ответа reload/panel, относящиеся только к перезагружаемой панели. */
export function scopeReloadPanelResultFields(
  resultFields: Record<string, unknown>,
  panelFieldKeys: ReadonlySet<string>,
): Record<string, unknown> {
  const scoped = scopeFieldMapToKeys(resultFields, panelFieldKeys)
  for (const [key, value] of Object.entries(resultFields)) {
    if (key.startsWith('$') && !(key in scoped)) {
      scoped[key] = value
    }
  }
  return scoped
}
